// extracted by mini-css-extract-plugin
export default {"MessageCell":"SystemMessagesTable_MessageCell__iIdNa","MessageText":"SystemMessagesTable_MessageText__dHVOt","Actions":"SystemMessagesTable_Actions__B2IEu"};